import React, { Component } from "react";
import ReactDOM from 'react-dom';
import { func, bool } from 'prop-types';
import ImgCheckCircleFilled from 'Atoms/ImgCheckCircleFilled';
import Currency from 'react-currency-formatter';
import CurrencyInput from 'react-currency-input';
import * as _ from 'lodash';
import bowser from 'bowser';

class PolicyPayOptions extends Component {
  constructor(props) {
    super(props)
    this.state = {
      noAmountIndicator: false,
      resetCustomAmount: false
    }
   // Debounce the update to avoid firing on every keystroke
    this.debouncedUpdate = _.debounce(() => {
      this.updateAccount(this.props.accounts);
    }, 2000); // Wait 500ms after user stops typing
  }


  componentDidMount() {
    //CHECK FOR IE
    if (bowser.msie || bowser.msedge) {
      this.props.actions.isIEFlag(true);
    }
    let policyId = this.props.props.policyId;
    let billingAccount = this.props.accounts[this.props.props.account.account_number];
    let selDate = billingAccount.minimum_due_date;

    let differenceInDays = this.calculateDays(selDate);
    let selectedIndicatorBool = (differenceInDays > 30) ? true : false;

    this.setState({
      noAmountIndicator: selectedIndicatorBool
    });

    this.removeClasses(policyId);


    _.forEach(this.props.accounts, (value, key) => {
      let selection = value.paymentOption;
      if (selection) {
        let element;
        if (selection === "min") {
          element = document.getElementById(`amount_due${key}`);
        } else if (selection === "Full payment") {
          element = document.getElementById(`pf${key}`);
        } else if (selection === "Other amount") {
          element = document.getElementById(`pc${key}`);
        } else if (selection === "No payment") {
          element = document.getElementById(`pn${key}`);
        }
        element && element.classList.add('selected');
      } else {
        let finAmtDue = document.getElementById(`amount_due${key}`);
        finAmtDue && finAmtDue.classList.add('selected');
      }
    })
    this.setState({
      resetCustomAmount: policyId.resetCustomAmount
    });
  }

  componentWillReceiveProps(nextProps) {
    let oldPolicy = this.props.accounts[this.props.props.account.account_number].policies[0];
    let oldSelDate = oldPolicy.due_date;

    let newSelPolicy = nextProps.accounts[nextProps.props.account.account_number].policies[0];
    let newSelDate = newSelPolicy.due_date;

    //recalculate selectedIndicatorBool if props changes.
    if (newSelDate !== oldSelDate) {
      let differenceInDays = this.calculateDays(newSelDate);
      let selectedIndicatorBool = (differenceInDays > 30) ? true : false;

      this.setState({
        noAmountIndicator: selectedIndicatorBool
      })
    }

    _.forEach(nextProps.accounts, (value, key) => {
      let selection = value.paymentOption;
      if (selection) {
        let element;
        if (selection === "min") {
          element = document.getElementById(`amount_due${key}`);
        } else if (selection === "Full payment") {
          element = document.getElementById(`pf${key}`);
        } else if (selection === "Other amount") {
          element = document.getElementById(`pc${key}`);
        } else if (selection === "No payment") {
          element = document.getElementById(`pn${key}`)
        }
        element && element.classList.add('selected');
      }
    })

    this.setState({
      resetCustomAmount: newSelPolicy.resetCustomAmount
    })
  }


  updateAccount = accountObject => {
    this.props.actions.updateAccountPayment(accountObject);
  };

  UpdateMinDue = (policynumber, policyTermId, minAmount) => {

    const amountDueNode = ReactDOM.findDOMNode(this.refs[`amountDue${policynumber}`]);
    this.props.accounts[this.props.props.account.account_number].policies.forEach(p => {
      if (p.policy_number === policynumber && p.policyTermId === policyTermId) {
        p.policy_amount = minAmount;
        p.paymentOption = "min";
      }
    })
    this.props.accounts[this.props.props.account.account_number].paymentOption = null;
    this.updateAccount(this.props.accounts);
    this.removeClasses(policynumber);
    amountDueNode && amountDueNode.classList.add("selected");

  };

  updatePayInFull = (policynumber, policyTermId, tamount) => {
    const fullPaymentNode = ReactDOM.findDOMNode(this.refs[`full_pay${policynumber}`]);
    this.props.accounts[this.props.props.account.account_number].policies.forEach(p => {
      if (p.policy_number === policynumber && p.policyTermId === policyTermId) {
        p.policy_amount = tamount;
        p.paymentOption = "Full payment";
      }
    })
    this.props.accounts[this.props.props.account.account_number].paymentOption = null;
    this.updateAccount(this.props.accounts);
    this.removeClasses(policynumber);
    fullPaymentNode && fullPaymentNode.classList.add("selected");

  };

  updateCustom = (policynumber) => {
    let tf = document.getElementById(('tf' + policynumber));

    const otherAmountNode = ReactDOM.findDOMNode(this.refs[`other_amount${policynumber}`]);

    this.props.accounts[this.props.props.account.account_number].paymentOption = null;
    this.updateAccount(this.props.accounts);
    this.removeClasses(policynumber);
    otherAmountNode && otherAmountNode.classList.add("selected");
    tf && document.getElementById('tf' + policynumber).focus();


  };

  updateNone = (policynumber, policyTermId) => {
    const noAmountNode = ReactDOM.findDOMNode(this.refs[`no_amount${policynumber}`]);

    this.props.accounts[this.props.props.account.account_number].policies.forEach(p => {
      if (p.policy_number === policynumber && p.policyTermId === policyTermId) {
        p.policy_amount = 0;
        p.paymentOption = "No payment";
      }
    })
    this.props.accounts[this.props.props.account.account_number].paymentOption = null;
    this.updateAccount(this.props.accounts);
    this.removeClasses(policynumber);
    noAmountNode && noAmountNode.classList.add("selected");

  }

  removeClasses = (policynumber) => {
    let amountDueNode = ReactDOM.findDOMNode(this.refs[`amountDue${policynumber}`]);
    let fullPaymentNode = ReactDOM.findDOMNode(this.refs[`full_pay${policynumber}`]);
    let otherAmountNode = ReactDOM.findDOMNode(this.refs[`other_amount${policynumber}`]);
    let noAmountNode = ReactDOM.findDOMNode(this.refs[`no_amount${policynumber}`]);
    amountDueNode && amountDueNode.classList.remove("selected");
    fullPaymentNode && fullPaymentNode.classList.remove("selected");
    otherAmountNode && otherAmountNode.classList.remove("selected");
    noAmountNode && noAmountNode.classList.remove("selected");
  }

  calculateDays = dateString => {
    // Set the unit values in milliseconds.
    let msecPerMinute = 1000 * 60;
    let msecPerHour = msecPerMinute * 60;
    let msecPerDay = msecPerHour * 24;

    // Set a date and get the milliseconds
    let date = new Date(dateString);
    let todayDate = new Date();
    let dateMsec = date.getTime();
    let todayDateMsec = todayDate.getTime();

    //get time difference
    let differenceInSec = dateMsec - todayDateMsec;
    let differenceInDays = Math.round(differenceInSec / msecPerDay) + 1;
    return differenceInDays;

  }



  customAmount = (policyId, policyTermId, event, maskedValue, floatvalue) => {
    this.props.accounts[this.props.props.account.account_number].policies.forEach(p => {
      if (p.policy_number === policyId && p.policyTermId === policyTermId) {
        p.policy_amount = floatvalue;
        p.paymentOption = "Other amount";
      }
    })
    // Dispatch the update immediately on every change
     this.debouncedUpdate();
  }

  // handleMinDueKeyUp = (e, policynumber) => {
  //   let passIEFlag = this.props.isIEFlag;
  //   if (e.keyCode === 13) {
  //     this.updateAmountDue(policynumber, passIEFlag);
  //   }
  // }

  // handleFullPaymentKeyUp = (e, policynumber) => {
  //   let passIEFlag = this.props.isIEFlag;
  //   if (e.keyCode === 13) {
  //     this.updatePayInFull(policynumber, passIEFlag);
  //   }
  // }
  // handleOtherAmountKeyUp = (e, policynumber) => {
  //   let passIEFlag = this.props.isIEFlag;
  //   if (e.keyCode === 13) {
  //     this.updateCustom(policynumber, passIEFlag);
  //     let tf = document.getElementById('tf' + policynumber);
  //     tf && tf.focus();
  //   }
  // }

  // handleNoPaymentKeyUp = (e, policynumber) => {
  //   let passIEFlag = this.props.isIEFlag;
  //   if (e.keyCode === 13) {
  //     this.updateNone(policynumber, passIEFlag);
  //   }
  // }

  render() {
    let policyId = this.props.props.policyId;
    let otherAmt = this.props.props.policy.policy_amount;
    let { noAmountIndicator, resetCustomAmount } = this.state;

    let customAmount;
    if (resetCustomAmount) {
      customAmount = "0.00"
    } else if (otherAmt && this.props.props.policy.paymentOption === "Other amount") {
      customAmount = otherAmt
    }

    //check if any payment option was clicked and select No payment accordingly
    let resetCustomAmountCheck = resetCustomAmount;


    return (
      <div className="payselect-list">
        <div
          id={"amount_due" + policyId}
          ref={`amountDue${policyId}`}
          tabIndex="0"
          className={noAmountIndicator ? "option" : "option selected"}
          onClick={() => { this.UpdateMinDue(policyId, this.props.props.policy.policyTermId, this.props.props.policy.min_due) }}>
          <ImgCheckCircleFilled className="green" />
          <ul>
            <li aria-label="Minimum due">Minimum due</li>
            <li>
              <Currency
                quantity={this.props.props.policy.min_due}
                pattern="!#,##0.00"
              />

            </li>
          </ul>
        </div>
        <div
          id={"pf" + policyId}
          ref={`full_pay${policyId}`}
          tabIndex="0"
          className="option"
          onClick={() => { this.updatePayInFull(policyId, this.props.props.policy.policyTermId, this.props.props.policy.total_due) }}
        >

          <ImgCheckCircleFilled className="green" />

          <ul>
            <li aria-label="Full payment balance">Full payment balance</li>
            <li>
              <Currency
                quantity={this.props.props.policy.total_due <= 0 ? 0 : this.props.props.policy.total_due}
                pattern="!#,##0.00"
              />
            </li>
          </ul>
        </div>
        <div
          id={"pc" + policyId}
          ref={`other_amount${policyId}`}
          tabIndex="0"
          className="option"
          onClick={() => { this.updateCustom(policyId, this.props.props.policy.policy_amount) }}>
          <ul>
            <ImgCheckCircleFilled className="green" />
            <li>Other amount</li>
            <li><CurrencyInput type="text" tabIndex="0" id={"tf" + policyId} autoFocus={false} ref="currInput" value={customAmount} onChangeEvent={(e, masked, float) =>
              this.customAmount(policyId, this.props.props.policy.policyTermId, e, masked, float)
            } className="pay_option_input" maxLength="10" /></li>

          </ul>
        </div>
        <div
          id={"pn" + policyId}
          ref={`no_amount${policyId}`}
          tabIndex="0"
          className={resetCustomAmountCheck ? "option" : noAmountIndicator ? "option selected" : "option"}
          onClick={() => { this.updateNone(policyId, this.props.props.policy.policyTermId) }}>
          <ImgCheckCircleFilled className="green" />
          <ul>
            <li aria-label="No payment"> No payment</li>
            <li>--</li>
          </ul>
        </div>
      </div>
    )
  }

}

PolicyPayOptions.propTypes = {
  updateAccount: func,
  UpdateMinDue: func,
  updatePayInFull: func,
  customAmount: func,
  updateNone: func,
  removeClasses: func,
  calculateDays: func,
  noAmountIndicator: bool,
};

export default PolicyPayOptions;


// WEBPACK FOOTER //
// ./src/components/atomic/molecules/PolicyPayOptions/PolicyPayOptions.js